import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  runTransaction,
  serverTimestamp,
  where,
} from "firebase/firestore";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import { db } from "../firebase";

import "./ConfirmedWithdraw.css";




// UI translations. Languages without a complete dictionary gracefully use English.
const confirmedWithdrawTranslations = {
  "sw": {
    "Loading withdrawal details...": "Inapakia maelezo ya kutoa fedha...",
    "Network not specified": "Mtandao haujabainishwa",
    "Confirm Withdrawal": "Thibitisha Utoaji wa Fedha",
    "Review your withdrawal details": "Kagua maelezo ya utoaji wa fedha",
    "Confirmed": "Imethibitishwa",
    "You will withdraw": "Utatoa",
    "Reference:": "Namba ya rejea:",
    "Withdrawal Details": "Maelezo ya Utoaji",
    "Withdrawal Speed": "Kasi ya Utoaji",
    "Withdrawal Type": "Aina ya Utoaji",
    "Withdrawal Fee": "Ada ya Utoaji",
    "Fee Amount": "Kiasi cha Ada",
    "Balance Source": "Chanzo cha Salio",
    "Available Balance": "Salio Lililopo",
    "Exchange Rate": "Kiwango cha Kubadilisha",
    "Amount to Receive": "Kiasi Utakachopokea",
    "CONFIRMED WITHDRAWAL": "THIBITISHA UTOAJI WA FEDHA",
    "DONE": "IMEKAMILIKA",
    "Crypto Wallet": "Mkoba wa Crypto",
    "RECEIVING ASSET": "MALI INAYOPOKELEWA",
    "NETWORK": "MTANDAO",
    "RECEIVING ADDRESS": "ANWANI YA KUPOKEA",
    "VERIFIED": "IMETHIBITISHWA",
    "WALLET ADDRESS": "ANWANI YA MKOBA",
    "PAYOUT CONVERSION": "UBADILISHAJI WA MALIPO",
    "Payment Information": "Taarifa za Malipo",
    "Mobile Wallet": "Mkoba wa Simu",
    "Wallet Code": "Msimbo wa Mkoba",
    "Country": "Nchi",
    "Your Information": "Taarifa Zako",
    "Name": "Jina",
    "Username": "Jina la Mtumiaji",
    "Phone": "Simu",
    "Not available": "Haipatikani",
    "Withdrawal password required": "Nenosiri la kutoa fedha linahitajika",
    "Confirm your withdrawal by entering": "Thibitisha utoaji wa fedha kwa kuingiza",
    "your withdrawal password.": "nenosiri lako la kutoa fedha.",
    "Withdrawal Password": "Nenosiri la Utoaji",
    "Enter your withdrawal password": "Weka nenosiri lako la kutoa fedha",
    "Enter withdrawal password": "Weka nenosiri la kutoa fedha",
    "Amount": "Kiasi",
    "Receive": "Pokea",
    "VERIFYING...": "INATHIBITISHA...",
    "SUBMITTING...": "INAWASILISHA...",
    "CONFIRM & VERIFY": "THIBITISHA NA HAKIKI",
    "Cancel": "Ghairi",
    "Password verified": "Nenosiri limethibitishwa",
    "Waiting for confirmation": "Inasubiri uthibitisho",
    "Processing": "Inachakatwa"
  },
  "fr": {
    "Loading withdrawal details...": "Chargement des détails du retrait...",
    "Network not specified": "Réseau non spécifié",
    "Confirm Withdrawal": "Confirmer le retrait",
    "Review your withdrawal details": "Vérifiez les détails de votre retrait",
    "Confirmed": "Confirmé",
    "You will withdraw": "Vous allez retirer",
    "Reference:": "Référence :",
    "Withdrawal Details": "Détails du retrait",
    "Withdrawal Speed": "Vitesse du retrait",
    "Withdrawal Type": "Type de retrait",
    "Withdrawal Fee": "Frais de retrait",
    "Fee Amount": "Montant des frais",
    "Balance Source": "Source du solde",
    "Available Balance": "Solde disponible",
    "Exchange Rate": "Taux de change",
    "Amount to Receive": "Montant à recevoir",
    "CONFIRMED WITHDRAWAL": "CONFIRMER LE RETRAIT",
    "DONE": "TERMINÉ",
    "Crypto Wallet": "Portefeuille crypto",
    "RECEIVING ASSET": "ACTIF À RECEVOIR",
    "NETWORK": "RÉSEAU",
    "RECEIVING ADDRESS": "ADRESSE DE RÉCEPTION",
    "VERIFIED": "VÉRIFIÉ",
    "WALLET ADDRESS": "ADRESSE DU PORTEFEUILLE",
    "PAYOUT CONVERSION": "CONVERSION DU PAIEMENT",
    "Payment Information": "Informations de paiement",
    "Mobile Wallet": "Portefeuille mobile",
    "Wallet Code": "Code du portefeuille",
    "Country": "Pays",
    "Your Information": "Vos informations",
    "Name": "Nom",
    "Username": "Nom d’utilisateur",
    "Phone": "Téléphone",
    "Not available": "Indisponible",
    "Withdrawal Password": "Mot de passe de retrait",
    "Enter your withdrawal password": "Saisissez votre mot de passe de retrait",
    "Enter withdrawal password": "Saisissez le mot de passe de retrait",
    "Amount": "Montant",
    "Receive": "Recevoir",
    "VERIFYING...": "VÉRIFICATION...",
    "SUBMITTING...": "ENVOI...",
    "CONFIRM & VERIFY": "CONFIRMER ET VÉRIFIER",
    "Cancel": "Annuler",
    "Password verified": "Mot de passe vérifié",
    "Waiting for confirmation": "En attente de confirmation"
  },
  "es": {
    "Loading withdrawal details...": "Cargando detalles del retiro...",
    "Network not specified": "Red no especificada",
    "Confirm Withdrawal": "Confirmar retiro",
    "Review your withdrawal details": "Revisa los detalles de tu retiro",
    "Confirmed": "Confirmado",
    "You will withdraw": "Retirarás",
    "Reference:": "Referencia:",
    "Withdrawal Details": "Detalles del retiro",
    "Withdrawal Speed": "Velocidad del retiro",
    "Withdrawal Type": "Tipo de retiro",
    "Withdrawal Fee": "Tarifa de retiro",
    "Fee Amount": "Importe de la tarifa",
    "Balance Source": "Origen del saldo",
    "Available Balance": "Saldo disponible",
    "Exchange Rate": "Tipo de cambio",
    "Amount to Receive": "Importe a recibir",
    "CONFIRMED WITHDRAWAL": "CONFIRMAR RETIRO",
    "DONE": "LISTO",
    "Crypto Wallet": "Billetera cripto",
    "RECEIVING ASSET": "ACTIVO A RECIBIR",
    "NETWORK": "RED",
    "RECEIVING ADDRESS": "DIRECCIÓN DE RECEPCIÓN",
    "VERIFIED": "VERIFICADO",
    "WALLET ADDRESS": "DIRECCIÓN DE BILLETERA",
    "PAYOUT CONVERSION": "CONVERSIÓN DEL PAGO",
    "Payment Information": "Información de pago",
    "Mobile Wallet": "Billetera móvil",
    "Wallet Code": "Código de billetera",
    "Country": "País",
    "Your Information": "Tu información",
    "Name": "Nombre",
    "Username": "Nombre de usuario",
    "Phone": "Teléfono",
    "Not available": "No disponible",
    "Withdrawal Password": "Contraseña de retiro",
    "Enter your withdrawal password": "Introduce tu contraseña de retiro",
    "Enter withdrawal password": "Introduce la contraseña de retiro",
    "Amount": "Importe",
    "Receive": "Recibir",
    "VERIFYING...": "VERIFICANDO...",
    "SUBMITTING...": "ENVIANDO...",
    "CONFIRM & VERIFY": "CONFIRMAR Y VERIFICAR",
    "Cancel": "Cancelar",
    "Password verified": "Contraseña verificada",
    "Waiting for confirmation": "Esperando confirmación"
  },
  "pt": {
    "Loading withdrawal details...": "Carregando detalhes do saque...",
    "Network not specified": "Rede não especificada",
    "Confirm Withdrawal": "Confirmar saque",
    "Review your withdrawal details": "Revise os detalhes do seu saque",
    "Confirmed": "Confirmado",
    "You will withdraw": "Você vai sacar",
    "Reference:": "Referência:",
    "Withdrawal Details": "Detalhes do saque",
    "Withdrawal Speed": "Velocidade do saque",
    "Withdrawal Type": "Tipo de saque",
    "Withdrawal Fee": "Taxa de saque",
    "Fee Amount": "Valor da taxa",
    "Balance Source": "Origem do saldo",
    "Available Balance": "Saldo disponível",
    "Exchange Rate": "Taxa de câmbio",
    "Amount to Receive": "Valor a receber",
    "CONFIRMED WITHDRAWAL": "CONFIRMAR SAQUE",
    "DONE": "CONCLUÍDO",
    "Crypto Wallet": "Carteira cripto",
    "RECEIVING ASSET": "ATIVO A RECEBER",
    "NETWORK": "REDE",
    "RECEIVING ADDRESS": "ENDEREÇO DE RECEBIMENTO",
    "VERIFIED": "VERIFICADO",
    "WALLET ADDRESS": "ENDEREÇO DA CARTEIRA",
    "PAYOUT CONVERSION": "CONVERSÃO DO PAGAMENTO",
    "Payment Information": "Informações de pagamento",
    "Mobile Wallet": "Carteira móvel",
    "Wallet Code": "Código da carteira",
    "Country": "País",
    "Your Information": "Suas informações",
    "Name": "Nome",
    "Username": "Nome de usuário",
    "Phone": "Telefone",
    "Not available": "Indisponível",
    "Withdrawal Password": "Senha de saque",
    "Enter your withdrawal password": "Digite sua senha de saque",
    "Enter withdrawal password": "Digite a senha de saque",
    "Amount": "Valor",
    "Receive": "Receber",
    "VERIFYING...": "VERIFICANDO...",
    "SUBMITTING...": "ENVIANDO...",
    "CONFIRM & VERIFY": "CONFIRMAR E VERIFICAR",
    "Cancel": "Cancelar",
    "Password verified": "Senha verificada",
    "Waiting for confirmation": "Aguardando confirmação"
  },
  "de": {
    "Loading withdrawal details...": "Auszahlungsdetails werden geladen...",
    "Network not specified": "Netzwerk nicht angegeben",
    "Confirm Withdrawal": "Auszahlung bestätigen",
    "Review your withdrawal details": "Überprüfen Sie Ihre Auszahlungsdetails",
    "Confirmed": "Bestätigt",
    "You will withdraw": "Sie heben ab",
    "Reference:": "Referenz:",
    "Withdrawal Details": "Auszahlungsdetails",
    "Withdrawal Speed": "Auszahlungsgeschwindigkeit",
    "Withdrawal Type": "Auszahlungsart",
    "Withdrawal Fee": "Auszahlungsgebühr",
    "Fee Amount": "Gebührenbetrag",
    "Balance Source": "Guthabenquelle",
    "Available Balance": "Verfügbares Guthaben",
    "Exchange Rate": "Wechselkurs",
    "Amount to Receive": "Zu erhaltender Betrag",
    "CONFIRMED WITHDRAWAL": "AUSZAHLUNG BESTÄTIGEN",
    "DONE": "FERTIG",
    "Crypto Wallet": "Krypto-Wallet",
    "RECEIVING ASSET": "EMPFANGENER VERMÖGENSWERT",
    "NETWORK": "NETZWERK",
    "RECEIVING ADDRESS": "EMPFANGSADRESSE",
    "VERIFIED": "VERIFIZIERT",
    "WALLET ADDRESS": "WALLET-ADRESSE",
    "PAYOUT CONVERSION": "AUSZAHLUNGSUMRECHNUNG",
    "Payment Information": "Zahlungsinformationen",
    "Mobile Wallet": "Mobile Wallet",
    "Wallet Code": "Wallet-Code",
    "Country": "Land",
    "Your Information": "Ihre Informationen",
    "Name": "Name",
    "Username": "Benutzername",
    "Phone": "Telefon",
    "Not available": "Nicht verfügbar",
    "Withdrawal Password": "Auszahlungspasswort",
    "Enter your withdrawal password": "Geben Sie Ihr Auszahlungspasswort ein",
    "Enter withdrawal password": "Auszahlungspasswort eingeben",
    "Amount": "Betrag",
    "Receive": "Erhalten",
    "VERIFYING...": "WIRD ÜBERPRÜFT...",
    "SUBMITTING...": "WIRD ÜBERMITTELT...",
    "CONFIRM & VERIFY": "BESTÄTIGEN & PRÜFEN",
    "Cancel": "Abbrechen",
    "Password verified": "Passwort bestätigt",
    "Waiting for confirmation": "Warten auf Bestätigung"
  },
  "it": {
    "Loading withdrawal details...": "Caricamento dettagli del prelievo...",
    "Network not specified": "Rete non specificata",
    "Confirm Withdrawal": "Conferma prelievo",
    "Review your withdrawal details": "Controlla i dettagli del prelievo",
    "Confirmed": "Confermato",
    "You will withdraw": "Preleverai",
    "Reference:": "Riferimento:",
    "Withdrawal Details": "Dettagli del prelievo",
    "Withdrawal Speed": "Velocità del prelievo",
    "Withdrawal Type": "Tipo di prelievo",
    "Withdrawal Fee": "Commissione di prelievo",
    "Fee Amount": "Importo della commissione",
    "Balance Source": "Origine del saldo",
    "Available Balance": "Saldo disponibile",
    "Exchange Rate": "Tasso di cambio",
    "Amount to Receive": "Importo da ricevere",
    "CONFIRMED WITHDRAWAL": "CONFERMA PRELIEVO",
    "DONE": "FATTO",
    "Crypto Wallet": "Portafoglio crypto",
    "RECEIVING ASSET": "ASSET IN RICEZIONE",
    "NETWORK": "RETE",
    "RECEIVING ADDRESS": "INDIRIZZO DI RICEZIONE",
    "VERIFIED": "VERIFICATO",
    "WALLET ADDRESS": "INDIRIZZO DEL PORTAFOGLIO",
    "PAYOUT CONVERSION": "CONVERSIONE DEL PAGAMENTO",
    "Payment Information": "Informazioni di pagamento",
    "Mobile Wallet": "Portafoglio mobile",
    "Wallet Code": "Codice portafoglio",
    "Country": "Paese",
    "Your Information": "Le tue informazioni",
    "Name": "Nome",
    "Username": "Nome utente",
    "Phone": "Telefono",
    "Not available": "Non disponibile",
    "Withdrawal Password": "Password di prelievo",
    "Enter your withdrawal password": "Inserisci la password di prelievo",
    "Enter withdrawal password": "Inserisci la password di prelievo",
    "Amount": "Importo",
    "Receive": "Ricevi",
    "VERIFYING...": "VERIFICA...",
    "SUBMITTING...": "INVIO...",
    "CONFIRM & VERIFY": "CONFERMA E VERIFICA",
    "Cancel": "Annulla",
    "Password verified": "Password verificata",
    "Waiting for confirmation": "In attesa di conferma"
  },
  "ar": {
    "Loading withdrawal details...": "جارٍ تحميل تفاصيل السحب...",
    "Network not specified": "لم يتم تحديد الشبكة",
    "Confirm Withdrawal": "تأكيد السحب",
    "Review your withdrawal details": "راجع تفاصيل السحب",
    "Confirmed": "تم التأكيد",
    "You will withdraw": "ستسحب",
    "Reference:": "المرجع:",
    "Withdrawal Details": "تفاصيل السحب",
    "Withdrawal Speed": "سرعة السحب",
    "Withdrawal Type": "نوع السحب",
    "Withdrawal Fee": "رسوم السحب",
    "Fee Amount": "مبلغ الرسوم",
    "Balance Source": "مصدر الرصيد",
    "Available Balance": "الرصيد المتاح",
    "Exchange Rate": "سعر الصرف",
    "Amount to Receive": "المبلغ المستلم",
    "CONFIRMED WITHDRAWAL": "تأكيد السحب",
    "DONE": "تم",
    "Crypto Wallet": "محفظة العملات الرقمية",
    "RECEIVING ASSET": "الأصل المستلم",
    "NETWORK": "الشبكة",
    "RECEIVING ADDRESS": "عنوان الاستلام",
    "VERIFIED": "تم التحقق",
    "WALLET ADDRESS": "عنوان المحفظة",
    "PAYOUT CONVERSION": "تحويل الدفع",
    "Payment Information": "معلومات الدفع",
    "Mobile Wallet": "محفظة الهاتف",
    "Wallet Code": "رمز المحفظة",
    "Country": "البلد",
    "Your Information": "معلوماتك",
    "Name": "الاسم",
    "Username": "اسم المستخدم",
    "Phone": "الهاتف",
    "Not available": "غير متاح",
    "Withdrawal Password": "كلمة مرور السحب",
    "Enter your withdrawal password": "أدخل كلمة مرور السحب",
    "Enter withdrawal password": "أدخل كلمة مرور السحب",
    "Amount": "المبلغ",
    "Receive": "استلام",
    "VERIFYING...": "جارٍ التحقق...",
    "SUBMITTING...": "جارٍ الإرسال...",
    "CONFIRM & VERIFY": "تأكيد والتحقق",
    "Cancel": "إلغاء",
    "Password verified": "تم التحقق من كلمة المرور",
    "Waiting for confirmation": "بانتظار التأكيد"
  }
};

const confirmedWithdrawLanguageCodes = ["en", "fr", "sw", "pt", "es", "ar", "zh", "hi", "bn", "ru", "de", "it", "nl", "tr", "ja", "ko", "vi", "th", "id", "ms", "ur", "fa", "ha", "yo", "zu", "am", "so", "rw", "lg", "af"];


/* =========================================================
   CONFIG
========================================================= */

const withdrawalOptions = [
  {
    id: "standard",
    label: "Standard",
    time: "24 Hours",
    fee: 5,
  },
  {
    id: "express",
    label: "Express",
    time: "30 Minutes",
    fee: 10,
  },
];


/* =========================================================
   BALANCE FIELDS
========================================================= */

const balanceFieldMap = {
  /*
    USDT is special.

    Actual source field comes from:
      balanceSource
      balanceType
      sourceBalanceField

    Default:
      usdtBalanceOther
  */

  USDT: "usdtBalanceOther",

  TZS: "tshBalance",
  KES: "KESBalance",
  UGX: "UGXBalance",
  RWF: "RWFBalance",
  BIF: "BIFBalance",
  ZMW: "ZMWBalance",
  MWK: "MWKBalance",
  MZN: "MZNBalance",
  USD: "USDBalance",
  SSP: "SSPBalance",
  BWP: "BWPBalance",
  MGA: "MGABalance",
};


/* =========================================================
   FORMAT AMOUNT
========================================================= */

const formatAmount = (
  value,
  currency = ""
) => {

  const number =
    Number(value || 0);

  if (
    !Number.isFinite(number)
  ) {
    return "0.00";
  }

  const normalizedCurrency =
    String(currency || "")
      .trim()
      .toUpperCase();

  if (
    normalizedCurrency ===
    "BTC"
  ) {

    return number.toLocaleString(
      undefined,
      {
        minimumFractionDigits: 8,
        maximumFractionDigits: 8,
      }
    );

  }

  return number.toLocaleString(
    undefined,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  );
};


/* =========================================================
   NORMALIZE PHONE / NUMBER
========================================================= */

const normalizePhone = (
  value = ""
) => {

  return String(
    value || ""
  )
    .trim()
    .replace(/\s+/g, "")
    .replace(/-/g, "")
    .replace(/\(/g, "")
    .replace(/\)/g, "");
};


/* =========================================================
   MASK PHONE
========================================================= */

const maskNumber = (
  number = ""
) => {

  const value =
    normalizePhone(number);

  if (!value) {
    return "Not available";
  }

  if (
    value.length <= 4
  ) {
    return value;
  }

  return `**${value.slice(-4)}`;
};


/* =========================================================
   MASK CRYPTO ADDRESS
========================================================= */

const maskCryptoAddress = (
  address = ""
) => {

  const value =
    String(address || "")
      .trim();

  if (!value) {
    return "Address not available";
  }

  if (
    value.length <= 18
  ) {
    return value;
  }

  return (
    value.slice(0, 10) +
    "••••••" +
    value.slice(-10)
  );
};


/* =========================================================
   NORMALIZE CURRENCY
========================================================= */

const normalizeCurrency = (
  value
) => {

  return String(
    value || ""
  )
    .trim()
    .toUpperCase();
};


/* =========================================================
   NORMALIZE STRING
========================================================= */

const clean = (
  value
) => {

  return String(
    value || ""
  ).trim();
};


/* =========================================================
   CONFIRMED WITHDRAW
========================================================= */

export default function ConfirmedWithdraw() {
  const [language, setLanguage] = useState(() => {
    try {
      return (localStorage.getItem("language") || "en").toLowerCase().split("-")[0];
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    const updateLanguage = (event) => {
      const next = event?.detail?.language || (() => {
        try { return localStorage.getItem("language") || "en"; } catch { return "en"; }
      })();
      setLanguage(String(next).toLowerCase().split("-")[0]);
    };
    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);
    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = (text) => confirmedWithdrawTranslations[language]?.[text] || text;

  const navigate =
    useNavigate();

  const location =
    useLocation();


  /* =======================================================
     USERNAME
  ======================================================= */

  const username =
    localStorage.getItem(
      "username"
    ) || "";


  /* =======================================================
     WITHDRAWAL DATA
  ======================================================= */

  const withdrawalData =
    location.state || null;


  /* =======================================================
     SECURITY
  ======================================================= */

  const [
    securityData,
    setSecurityData,
  ] = useState(null);


  /* =======================================================
     USER
  ======================================================= */

  const [
    userData,
    setUserData,
  ] = useState(null);


  /* =======================================================
     USER DOCUMENT ID
  ======================================================= */

  const [
    userId,
    setUserId,
  ] = useState("");


  /* =======================================================
     LOADING
  ======================================================= */

  const [
    loading,
    setLoading,
  ] = useState(true);


  /* =======================================================
     PASSWORD
  ======================================================= */

  const [
    withdrawPassword,
    setWithdrawPassword,
  ] = useState("");


  const [
    showPassword,
    setShowPassword,
  ] = useState(false);


  const [
    passwordOpen,
    setPasswordOpen,
  ] = useState(false);


  const [
    passwordError,
    setPasswordError,
  ] = useState("");


  /* =======================================================
     SUBMISSION
  ======================================================= */

  const [
    verifying,
    setVerifying,
  ] = useState(false);


  const [
    savingWithdrawal,
    setSavingWithdrawal,
  ] = useState(false);


  const [
    verified,
    setVerified,
  ] = useState(false);


  /* =======================================================
     RESULT
  ======================================================= */

  const [
    successMessage,
    setSuccessMessage,
  ] = useState("");


  const [
    withdrawalId,
    setWithdrawalId,
  ] = useState("");


  /* =======================================================
     LOAD USER + SECURITY
  ======================================================= */

  useEffect(() => {

    let mounted = true;

    const loadData =
      async () => {

        if (!username) {

          if (mounted) {
            setLoading(false);
          }

          navigate(
            "/login",
            {
              replace: true,
            }
          );

          return;
        }

        try {

          /* =============================================
             SECURITY
          ============================================= */

          const securityRef =
            doc(
              db,
              "security",
              username
            );

          const securitySnapshot =
            await getDoc(
              securityRef
            );

          if (!mounted) {
            return;
          }

          if (
            !securitySnapshot.exists()
          ) {

            setLoading(false);

            navigate(
              "/profile",
              {
                replace: true,
              }
            );

            return;
          }

          const loadedSecurity =
            securitySnapshot.data();

          setSecurityData(
            loadedSecurity
          );


          /* =============================================
             USER
          ============================================= */

          const userQuery =
            query(
              collection(
                db,
                "users"
              ),
              where(
                "username",
                "==",
                username
              )
            );

          const userSnapshot =
            await getDocs(
              userQuery
            );

          if (!mounted) {
            return;
          }

          if (
            userSnapshot.empty
          ) {

            setLoading(false);

            return;
          }

          const userDoc =
            userSnapshot.docs[0];

          setUserId(
            userDoc.id
          );

          setUserData(
            userDoc.data()
          );

        } catch (error) {

          console.error(
            "Confirmed withdrawal loading error:",
            error
          );

        } finally {

          if (mounted) {
            setLoading(false);
          }

        }
      };

    loadData();

    return () => {
      mounted = false;
    };

  }, [
    username,
    navigate,
  ]);


  /* =======================================================
     NO WITHDRAWAL DATA
  ======================================================= */

  useEffect(() => {

    if (
      !loading &&
      !withdrawalData
    ) {

      navigate(
        "/withdraw",
        {
          replace: true,
        }
      );

    }

  }, [
    loading,
    withdrawalData,
    navigate,
  ]);


  /* =======================================================
     SOURCE CURRENCY
  ======================================================= */

  const currency =
    normalizeCurrency(
      withdrawalData?.currency ||
      withdrawalData?.sourceCurrency ||
      "USDT"
    );


  /* =======================================================
     PAYOUT / RECEIVE CURRENCY
  ======================================================= */

  const receiveCurrency =
    normalizeCurrency(
      withdrawalData?.payoutCurrency ||
      withdrawalData?.receiveCurrency ||
      withdrawalData?.targetCurrency ||
      currency
    );


  /* =======================================================
     PAYOUT CURRENCY
  ======================================================= */

  const payoutCurrency =
    currency === "USDT"
      ? receiveCurrency
      : currency;


  /* =======================================================
     USDT BALANCE SOURCE
  ======================================================= */

  const requestedBalanceSource =
    clean(
      withdrawalData?.balanceSource ||
      withdrawalData?.balanceType ||
      withdrawalData?.sourceBalanceField ||
      ""
    );


  const balanceSource =
    currency === "USDT"
      ? (
          requestedBalanceSource ===
            "usdtBalance"
          ||
          requestedBalanceSource ===
            "usdtBalanceOther"
            ? requestedBalanceSource
            : "usdtBalanceOther"
        )
      : (
          balanceFieldMap[currency] ||
          ""
        );


  /* =======================================================
     AVAILABLE BALANCE
  ======================================================= */

  const availableBalance =
    Number(
      withdrawalData?.availableBalance || 0
    );


  /* =======================================================
     WITHDRAWAL TYPE
  ======================================================= */

  const withdrawalType =
    clean(
      withdrawalData?.withdrawalType
    );


  /* =======================================================
     SELECTED WITHDRAWAL OPTION
  ======================================================= */

  const selectedWithdrawalOption =
    useMemo(
      () => {

        return (
          withdrawalOptions.find(
            (option) =>
              option.id ===
              withdrawalType
          ) || null
        );

      },
      [
        withdrawalType,
      ]
    );


  /* =======================================================
     FEE RATE
  ======================================================= */

  const feeRate =
    Number(
      selectedWithdrawalOption?.fee || 0
    );


  /* =======================================================
     SOURCE AMOUNT
  ======================================================= */

  const amount =
    Number(
      withdrawalData?.amount || 0
    );


  /* =======================================================
     FEE AMOUNT
  ======================================================= */

  const feeAmount =
    amount > 0 &&
    feeRate >= 0
      ? (
          amount *
          feeRate
        ) / 100
      : 0;


  /* =======================================================
     SOURCE AMOUNT AFTER FEE
  ======================================================= */

  const actualSourceAmount =
    Math.max(
      amount -
      feeAmount,
      0
    );


  /* =======================================================
     EXCHANGE RATE
  ======================================================= */

  const exchangeRate =
    Number(
      withdrawalData?.exchangeRate ||
      withdrawalData?.payoutRate ||
      withdrawalData?.rate ||
      0
    );


  /* =======================================================
     BTC RATE
  ======================================================= */

  const conversionRate =
    Number(
      withdrawalData?.conversionRate || 0
    );


  /* =======================================================
     REQUESTED WALLET
  ======================================================= */

  const requestedWallet =
    withdrawalData?.wallet || {};


  /* =======================================================
     WALLET COIN
  ======================================================= */

  const requestedWalletCoin =
    normalizeCurrency(
      requestedWallet.coin ||
      requestedWallet.selectedCoin ||
      requestedWallet.walletCoin ||
      ""
    );


  /* =======================================================
     WALLET NETWORK
  ======================================================= */

  const requestedWalletNetwork =
    clean(
      requestedWallet.network ||
      requestedWallet.selectedNetwork ||
      requestedWallet.network1 ||
      requestedWallet.selectedNetwork1 ||
      ""
    );


  /* =======================================================
     {t("WALLET ADDRESS")}
  ======================================================= */

  const requestedWalletAddress =
    clean(
      requestedWallet.address ||
      requestedWallet.selectedAddress ||
      requestedWallet.walletAddress ||
      ""
    );


  /* =======================================================
     SELECTED WALLET NUMBER
     
     IMPORTANT:
     This reads the exact number selected
     from Withdraw.js.
  ======================================================= */

  const requestedWalletNumber =
    normalizePhone(
      requestedWallet.number ||
      requestedWallet.phoneNumber ||
      requestedWallet.selectedNumber ||
      requestedWallet.selectedPhone ||
      requestedWallet.selectedPhoneNumber ||
      requestedWallet.walletNumber ||
      requestedWallet.phoneNumber1 ||
      ""
    );


  /* =======================================================
     WALLET SLOT
  ======================================================= */

  const requestedWalletSlot =
    clean(
      requestedWallet.walletSlot ||
      requestedWallet.selectedWalletType ||
      requestedWallet.slot ||
      requestedWallet.selectedSlot ||
      ""
    );


  /* =======================================================
     WALLET CODE
  ======================================================= */

  const requestedWalletCode =
    clean(
      requestedWallet.code ||
      requestedWallet.walletCode ||
      ""
    );


  /* =======================================================
     WALLET COUNTRY
  ======================================================= */

  const requestedWalletCountry =
    clean(
      requestedWallet.country ||
      requestedWallet.walletCountry ||
      ""
    );


  /* =======================================================
     BTC
  ======================================================= */

  const isBTC =
    receiveCurrency === "BTC" ||
    requestedWalletCoin.includes(
      "BTC"
    ) ||
    normalizeCurrency(
      withdrawalData?.wallet?.coin
    ).includes(
      "BTC"
    );


  /* =======================================================
     WALLET PAYOUT CURRENCY
  ======================================================= */

  const walletPayoutCurrency =
    currency === "USDT"
      ? payoutCurrency
      : currency;


  /* =======================================================
     CRYPTO DETECTION
     
     USDT -> TZS:
       false

     USDT -> KES:
       false

     USDT -> USDT wallet:
       true

     BTC:
       true
  ======================================================= */

  const isCrypto =
    isBTC ||
    (
      requestedWalletAddress &&
      (
        requestedWalletCoin.includes(
          "BTC"
        ) ||
        requestedWalletCoin.includes(
          "USDT"
        ) ||
        receiveCurrency === "BTC" ||
        receiveCurrency === "USDT"
      )
    );


  /* =======================================================
     USDT -> LOCAL PAYOUT
  ======================================================= */

  const usdtToLocalPayout =
    currency === "USDT" &&
    !isBTC &&
    receiveCurrency !== "USDT"
      ? actualSourceAmount *
        exchangeRate
      : 0;


  /* =======================================================
     BTC RECEIVE AMOUNT
  ======================================================= */

  const actualAmountBtc =
    isBTC &&
    conversionRate > 0
      ? actualSourceAmount *
        conversionRate
      : 0;


  /* =======================================================
     USDT RECEIVE AMOUNT
  ======================================================= */

  const actualAmountUsdt =
    currency === "USDT"
      ? actualSourceAmount
      : 0;


  /* =======================================================
     LOCAL RECEIVE AMOUNT
  ======================================================= */

  const actualLocalAmount =
    currency === "USDT" &&
    !isBTC &&
    receiveCurrency !== "USDT"
      ? usdtToLocalPayout
      : actualSourceAmount;


  /* =======================================================
     DISPLAY RECEIVE AMOUNT
  ======================================================= */

  const displayReceiveAmount =
    isBTC
      ? actualAmountBtc
      : (
          currency === "USDT" &&
          receiveCurrency !== "USDT"
            ? usdtToLocalPayout
            : actualSourceAmount
        );


  /* =======================================================
     DISPLAY RECEIVE CURRENCY
  ======================================================= */

  const displayReceiveCurrency =
    isBTC
      ? "BTC"
      : receiveCurrency;


  /* =======================================================
     OPEN PASSWORD
  ======================================================= */

  const handleConfirmedClick =
    () => {

      if (
        verified ||
        savingWithdrawal
      ) {
        return;
      }

      setPasswordError("");
      setWithdrawPassword("");
      setShowPassword(false);
      setSuccessMessage("");
      setPasswordOpen(true);

    };


  /* =======================================================
     CLOSE PASSWORD
  ======================================================= */

  const closePassword =
    () => {

      if (
        verifying ||
        savingWithdrawal
      ) {
        return;
      }

      setPasswordOpen(false);
      setPasswordError("");
      setWithdrawPassword("");
      setShowPassword(false);

    };


  /* =======================================================
     LOAD CANONICAL WALLET
  ======================================================= */

  const getCanonicalWallet =
    async () => {

      if (!username) {

        throw new Error(
          "User session is not available."
        );

      }


      /* ===============================================
         CRYPTO WALLET
      =============================================== */

      if (isCrypto) {

        const securityRef =
          doc(
            db,
            "security",
            username
          );

        const snapshot =
          await getDoc(
            securityRef
          );

        if (
          !snapshot.exists()
        ) {

          throw new Error(
            "Security wallet information was not found."
          );

        }

        const data =
          snapshot.data();


        const cryptoWallets =
          Array.isArray(
            data.cryptoWallets
          )
            ? data.cryptoWallets
            : [];


        const matchedWallet =
          cryptoWallets.find(
            (wallet) => {

              if (!wallet) {
                return false;
              }


              const address =
                clean(
                  wallet.address
                );


              const coin =
                normalizeCurrency(
                  wallet.coin
                );


              const network =
                clean(
                  wallet.network
                );


              return (
                address &&
                address ===
                  requestedWalletAddress &&
                (
                  !requestedWalletCoin ||
                  coin ===
                    requestedWalletCoin
                ) &&
                (
                  !requestedWalletNetwork ||
                  network ===
                    requestedWalletNetwork
                )
              );

            }
          );


        if (!matchedWallet) {

          throw new Error(
            "Selected crypto wallet could not be verified."
          );

        }


        return {

          ...matchedWallet,

          address:
            clean(
              matchedWallet.address
            ),

          coin:
            clean(
              matchedWallet.coin
            ),

          network:
            clean(
              matchedWallet.network
            ),

        };

      }


      /* ===============================================
         TANZANIA MOBILE WALLET
      =============================================== */

      if (
        walletPayoutCurrency ===
        "TZS"
      ) {

        const phoneWalletRef =
          doc(
            db,
            "phoneWallet",
            username
          );


        const snapshot =
          await getDoc(
            phoneWalletRef
          );


        if (
          !snapshot.exists()
        ) {

          throw new Error(
            "Mobile wallet was not found."
          );

        }


        const wallet =
          snapshot.data();


        /* =============================================
           SAVED NUMBERS
        ============================================= */

        const phone1 =
          normalizePhone(
            wallet.phoneNumber1 ||
            wallet.number1 ||
            ""
          );


        const phone2 =
          normalizePhone(
            wallet.phoneNumber2 ||
            wallet.number2 ||
            ""
          );


        /* =============================================
           SAVED NETWORKS
        ============================================= */

        const network1 =
          clean(
            wallet.network1 ||
            wallet.network ||
            ""
          );


        const network2 =
          clean(
            wallet.network2 ||
            ""
          );


        /* =============================================
           EXACT SELECTED NUMBER MATCH
           
           IMPORTANT:
           We check the selected number FIRST.
           
           We do NOT automatically select phone1.
        ============================================= */

        let canonicalNumber = "";
        let canonicalNetwork = "";
        let detectedSlot = "";


        /* =============================================
           SELECTED NUMBER = PRIMARY
        ============================================= */

        if (
          requestedWalletNumber &&
          requestedWalletNumber ===
            phone1
        ) {

          canonicalNumber =
            phone1;

          canonicalNetwork =
            network1;

          detectedSlot =
            "primary";

        }


        /* =============================================
           SELECTED NUMBER = SECONDARY
        ============================================= */

        if (
          !canonicalNumber &&
          requestedWalletNumber &&
          requestedWalletNumber ===
            phone2
        ) {

          canonicalNumber =
            phone2;

          canonicalNetwork =
            network2;

          detectedSlot =
            "secondary";

        }


        /* =============================================
           NUMBER NOT FOUND
           
           Only now use wallet slot.
        ============================================= */

        if (
          !canonicalNumber
        ) {

          if (
            requestedWalletSlot ===
            "secondary"
          ) {

            canonicalNumber =
              phone2;

            canonicalNetwork =
              network2;

            detectedSlot =
              "secondary";

          } else if (
            requestedWalletSlot ===
            "primary"
          ) {

            canonicalNumber =
              phone1;

            canonicalNetwork =
              network1;

            detectedSlot =
              "primary";

          }

        }


        /* =============================================
           FINAL VALIDATION
        ============================================= */

        if (
          !canonicalNumber
        ) {

          throw new Error(
            "The selected mobile wallet number was not found in your saved wallets."
          );

        }


        if (
          !canonicalNetwork
        ) {

          throw new Error(
            "The selected mobile wallet network was not found."
          );

        }


        /* =============================================
           NUMBER MUST MATCH
        ============================================= */

        if (
          requestedWalletNumber &&
          canonicalNumber !==
            requestedWalletNumber
        ) {

          throw new Error(
            "Selected mobile wallet number no longer matches your saved wallet."
          );

        }


        /* =============================================
           NETWORK MUST MATCH
        ============================================= */

        if (
          requestedWalletNetwork &&
          canonicalNetwork !==
            requestedWalletNetwork
        ) {

          throw new Error(
            "Selected mobile wallet network no longer matches your saved wallet."
          );

        }


        /* =============================================
           RETURN EXACT SELECTED WALLET
        ============================================= */

        return {

          country:
            "Tanzania",

          code:
            "+255",

          currency:
            "TZS",

          number:
            canonicalNumber,

          phoneNumber:
            canonicalNumber,

          phoneNumber1:
            phone1,

          phoneNumber2:
            phone2,

          network:
            canonicalNetwork,

          network1:
            network1,

          network2:
            network2,

          walletSlot:
            detectedSlot ||
            requestedWalletSlot ||
            (
              canonicalNumber ===
              phone2
                ? "secondary"
                : "primary"
            ),

        };

      }


      /* ===============================================
         OTHER COUNTRY MOBILE WALLET
      =============================================== */

      const securityRef =
        doc(
          db,
          "security",
          username
        );


      const snapshot =
        await getDoc(
          securityRef
        );


      if (
        !snapshot.exists()
      ) {

        throw new Error(
          "Wallet information was not found."
        );

      }


      const data =
        snapshot.data();


      const savedWallets =
        Array.isArray(
          data.wallets
        )
          ? data.wallets
          : [];


      const matchedWallet =
        savedWallets.find(
          (wallet) => {

            if (!wallet) {
              return false;
            }


            const walletCurrency =
              normalizeCurrency(
                wallet.currency
              );


            const walletNumber =
              normalizePhone(
                wallet.phoneNumber1 ||
                wallet.number ||
                wallet.phoneNumber ||
                wallet.selectedNumber ||
                ""
              );


            const walletNetwork =
              clean(
                wallet.network1 ||
                wallet.network ||
                wallet.selectedNetwork ||
                ""
              );


            return (
              walletCurrency ===
                walletPayoutCurrency &&

              walletNumber ===
                requestedWalletNumber &&

              walletNetwork ===
                requestedWalletNetwork &&

              wallet.walletSecured ===
                true
            );

          }
        );


      if (
        !matchedWallet
      ) {

        throw new Error(
          `Selected ${walletPayoutCurrency} payment wallet could not be verified.`
        );

      }


      const matchedNumber =
        normalizePhone(
          matchedWallet.phoneNumber1 ||
          matchedWallet.number ||
          matchedWallet.phoneNumber ||
          matchedWallet.selectedNumber ||
          ""
        );


      const matchedNetwork =
        clean(
          matchedWallet.network1 ||
          matchedWallet.network ||
          matchedWallet.selectedNetwork ||
          ""
        );


      return {

        ...matchedWallet,

        number:
          matchedNumber,

        phoneNumber:
          matchedNumber,

        network:
          matchedNetwork,

        currency:
          normalizeCurrency(
            matchedWallet.currency
          ),

      };

    };


  /* =======================================================
     SAVE WITHDRAWAL + DEDUCT BALANCE
  ======================================================= */

  const saveWithdrawalAndDeductBalance =
    async () => {

      if (!withdrawalData) {

        throw new Error(
          "Withdrawal information is missing."
        );

      }


      if (!username) {

        throw new Error(
          "User session is not available."
        );

      }


      if (!userId) {

        throw new Error(
          "User account could not be identified."
        );

      }


      /* ===============================================
         VALID BALANCE FIELD
      =============================================== */

      if (!balanceSource) {

        throw new Error(
          `Unsupported withdrawal currency: ${currency}`
        );

      }


      /* ===============================================
         USDT LOCAL PAYOUT RATE
      =============================================== */

      if (
        currency === "USDT" &&
        !isBTC &&
        receiveCurrency !== "USDT"
      ) {

        if (
          !Number.isFinite(
            exchangeRate
          ) ||
          exchangeRate <= 0
        ) {

          throw new Error(
            `Missing exchange rate for USDT to ${receiveCurrency} payout.`
          );

        }

      }


      /* ===============================================
         VALID AMOUNT
      =============================================== */

      if (
        !Number.isFinite(amount) ||
        amount <= 0
      ) {

        throw new Error(
          "Invalid withdrawal amount."
        );

      }


      /* ===============================================
         AVAILABLE BALANCE CHECK
      =============================================== */

      if (
        availableBalance > 0 &&
        amount >
          availableBalance
      ) {

        throw new Error(
          "Withdrawal amount is greater than the selected available balance."
        );

      }


      /* ===============================================
         WITHDRAWAL TYPE
      =============================================== */

      if (
        !selectedWithdrawalOption
      ) {

        throw new Error(
          "Invalid withdrawal speed."
        );

      }


      /* ===============================================
         FEE
      =============================================== */

      const finalFee =
        Number(
          selectedWithdrawalOption.fee
        );


      const finalFeeAmount =
        (
          amount *
          finalFee
        ) / 100;


      const finalReceiveSourceAmount =
        amount -
        finalFeeAmount;


      if (
        finalReceiveSourceAmount <= 0
      ) {

        throw new Error(
          "Withdrawal amount is too small after processing fee."
        );

      }


      /* ===============================================
         FINAL PAYOUT
      =============================================== */

      const finalPayoutAmount =
        isBTC
          ? actualAmountBtc
          : (
              currency === "USDT" &&
              receiveCurrency !== "USDT"
                ? finalReceiveSourceAmount *
                  exchangeRate
                : finalReceiveSourceAmount
            );


      if (
        !Number.isFinite(
          finalPayoutAmount
        ) ||
        finalPayoutAmount <= 0
      ) {

        throw new Error(
          "Invalid payout amount."
        );

      }


      /* ===============================================
         CANONICAL WALLET
      =============================================== */

      const canonicalWallet =
        await getCanonicalWallet();


      /* ===============================================
         USER REF
      =============================================== */

      const userRef =
        doc(
          db,
          "users",
          userId
        );


      /* ===============================================
         WITHDRAWAL REF
      =============================================== */

      const withdrawalRef =
        doc(
          collection(
            db,
            "withdrawals"
          )
        );


      /* ===============================================
         WALLET VALUES
      =============================================== */

      const walletCoin =
        normalizeCurrency(
          canonicalWallet.coin ||
          canonicalWallet.selectedCoin ||
          ""
        );


      const walletAddress =
        clean(
          canonicalWallet.address ||
          canonicalWallet.selectedAddress ||
          ""
        );


      const walletNetwork =
        clean(
          canonicalWallet.network ||
          canonicalWallet.selectedNetwork ||
          ""
        );


      const walletNumber =
        normalizePhone(
          canonicalWallet.number ||
          canonicalWallet.phoneNumber ||
          canonicalWallet.phoneNumber1 ||
          ""
        );


      const walletCode =
        clean(
          canonicalWallet.code ||
          canonicalWallet.walletCode ||
          ""
        );


      const walletCountry =
        clean(
          canonicalWallet.country ||
          canonicalWallet.walletCountry ||
          ""
        );


      /* ===============================================
         FINAL SELECTED WALLET VALIDATION
      =============================================== */

      if (
        !isCrypto &&
        requestedWalletNumber &&
        walletNumber !==
          requestedWalletNumber
      ) {

        throw new Error(
          "The selected wallet number changed before confirmation."
        );

      }


      if (
        !isCrypto &&
        requestedWalletNetwork &&
        walletNetwork !==
          requestedWalletNetwork
      ) {

        throw new Error(
          "The selected wallet network changed before confirmation."
        );

      }


      /* ===============================================
         CRYPTO VALIDATION
      =============================================== */

      if (
        isCrypto &&
        !walletAddress
      ) {

        throw new Error(
          "Crypto wallet address is missing."
        );

      }


      if (
        isCrypto &&
        !walletNetwork
      ) {

        throw new Error(
          "Crypto wallet network is missing."
        );

      }


      /* ===============================================
         MOBILE VALIDATION
      =============================================== */

      if (
        !isCrypto &&
        !walletNumber
      ) {

        throw new Error(
          "Mobile wallet number is missing."
        );

      }


      /* ===============================================
         FIRESTORE TRANSACTION
      =============================================== */

      await runTransaction(
        db,
        async (
          transaction
        ) => {

          /* =========================================
             FRESH USER
          ========================================= */

          const userSnapshot =
            await transaction.get(
              userRef
            );


          if (
            !userSnapshot.exists()
          ) {

            throw new Error(
              "User account was not found."
            );

          }


          const freshUserData =
            userSnapshot.data();


          /* =========================================
             VERIFY USERNAME
          ========================================= */

          const firebaseUsername =
            clean(
              freshUserData.username
            );


          if (
            firebaseUsername !==
            username
          ) {

            throw new Error(
              "User account verification failed."
            );

          }


          /* =========================================
             FRESH SOURCE BALANCE
          ========================================= */

          const currentBalance =
            Number(
              freshUserData[
                balanceSource
              ] || 0
            );


          if (
            !Number.isFinite(
              currentBalance
            )
          ) {

            throw new Error(
              `Unable to read ${balanceSource} balance.`
            );

          }


          /* =========================================
             BALANCE CHECK
          ========================================= */

          if (
            currentBalance <
            amount
          ) {

            throw new Error(
              `Insufficient balance. Available ${currency} balance is ${currentBalance}.`
            );

          }


          /* =========================================
             NEW BALANCE
          ========================================= */

          const newBalance =
            currentBalance -
            amount;


          if (
            newBalance < 0
          ) {

            throw new Error(
              "Invalid resulting balance."
            );

          }


          /* =========================================
             UPDATE SOURCE BALANCE
             
             USDT:
               usdtBalanceOther OR usdtBalance

             Local wallet balance is NOT deducted
             when source is USDT.
          ========================================= */

          transaction.update(
            userRef,
            {

              [balanceSource]:
                newBalance,

              updatedAt:
                serverTimestamp(),

            }
          );


          /* =========================================
             WITHDRAWAL DOCUMENT
          ========================================= */

          transaction.set(
            withdrawalRef,
            {

              /* ================================
                 USER
              ================================= */

              userId:
                userId,

              username:
                username,

              realName:
                clean(
                  securityData?.realName ||
                  freshUserData?.realName ||
                  ""
                ),


              /* ================================
                 SOURCE
              ================================= */

              amount:
                Number(
                  amount.toFixed(8)
                ),

              currency:
                currency,

              sourceCurrency:
                currency,


              /* ================================
                 PAYOUT
              ================================= */

              targetCurrency:
                displayReceiveCurrency,

              receiveCurrency:
                displayReceiveCurrency,

              payoutCurrency:
                payoutCurrency,

              payoutAmount:
                Number(
                  finalPayoutAmount.toFixed(
                    isBTC
                      ? 8
                      : 6
                  )
                ),


              /* ================================
                 SOURCE AFTER FEE
              ================================= */

              sourceAmountAfterFee:
                Number(
                  finalReceiveSourceAmount.toFixed(
                    8
                  )
                ),


              /* ================================
                 USDT
              ================================= */

              actualAmountUsdt:
                currency === "USDT"
                  ? Number(
                      finalReceiveSourceAmount.toFixed(
                        8
                      )
                    )
                  : 0,

              usdtAmount:
                currency === "USDT"
                  ? Number(
                      finalReceiveSourceAmount.toFixed(
                        8
                      )
                    )
                  : 0,


              /* ================================
                 LOCAL EQUIVALENT
              ================================= */

              localEquivalent:
                currency === "USDT" &&
                receiveCurrency !== "USDT"
                  ? Number(
                      finalPayoutAmount.toFixed(
                        6
                      )
                    )
                  : 0,


              /* ================================
                 ACTUAL LOCAL PAYOUT
              ================================= */

              payoutAmountLocal:
                currency === "USDT" &&
                receiveCurrency !== "USDT"
                  ? Number(
                      finalPayoutAmount.toFixed(
                        6
                      )
                    )
                  : 0,


              /* ================================
                 BTC
              ================================= */

              actualAmountBtc:
                isBTC
                  ? Number(
                      actualAmountBtc.toFixed(
                        8
                      )
                    )
                  : 0,


              /* ================================
                 BTC RATE
              ================================= */

              conversionRate:
                isBTC &&
                conversionRate > 0
                  ? conversionRate
                  : 0,


              /* ================================
                 PAYOUT RATE
              ================================= */

              exchangeRate:
                currency === "USDT" &&
                receiveCurrency !== "USDT"
                  ? exchangeRate
                  : 0,

              payoutRate:
                currency === "USDT" &&
                receiveCurrency !== "USDT"
                  ? exchangeRate
                  : 0,


              /* ================================
                 FEE
              ================================= */

              fee:
                finalFee,

              feeAmount:
                Number(
                  finalFeeAmount.toFixed(
                    8
                  )
                ),


              /* ================================
                 WITHDRAWAL SPEED
              ================================= */

              withdrawalType:
                selectedWithdrawalOption.id,

              withdrawalSpeed:
                selectedWithdrawalOption.label,

              processingTime:
                selectedWithdrawalOption.time,


              /* ================================
                 WALLET
              ================================= */

              wallet:
                canonicalWallet,

              walletCoin:
                walletCoin,

              walletAddress:
                walletAddress,

              walletNetwork:
                walletNetwork,

              walletCode:
                walletCode,

              walletNumber:
                walletNumber,

              walletPhoneNumber1:
                canonicalWallet.phoneNumber1 ||
                "",

              walletPhoneNumber2:
                canonicalWallet.phoneNumber2 ||
                "",

              walletCountry:
                walletCountry,


              /* ================================
                 SELECTED WALLET SLOT
              ================================= */

              walletSlot:
                canonicalWallet.walletSlot ||
                requestedWalletSlot ||
                "",


              /* ================================
                 WALLET PAYOUT CURRENCY
              ================================= */

              walletPayoutCurrency:
                walletPayoutCurrency,


              /* ================================
                 CRYPTO
              ================================= */

              isCrypto:
                Boolean(isCrypto),

              isBTC:
                Boolean(isBTC),


              /* ================================
                 BALANCE SOURCE
              ================================= */

              balanceField:
                balanceSource,

              sourceBalanceField:
                balanceSource,

              balanceType:
                currency === "USDT"
                  ? balanceSource
                  : currency,

              balanceSource:
                currency === "USDT"
                  ? balanceSource
                  : currency,

              availableBalance:
                Number(
                  currentBalance.toFixed(
                    8
                  )
                ),

              balanceBefore:
                Number(
                  currentBalance.toFixed(
                    8
                  )
                ),

              balanceAfter:
                Number(
                  newBalance.toFixed(
                    8
                  )
                ),


              /* ================================
                 SELECTED NUMBER AUDIT
              ================================= */

              selectedWalletNumber:
                walletNumber,

              selectedWalletNetwork:
                walletNetwork,


              /* ================================
                 STATUS
              ================================= */

              status:
                "processing",


              /* ================================
                 SECURITY
              ================================= */

              passwordVerified:
                true,


              /* ================================
                 TIMESTAMPS
              ================================= */

              createdAt:
                serverTimestamp(),

              confirmedAt:
                serverTimestamp(),

              updatedAt:
                serverTimestamp(),

            }
          );

        }
      );


      return withdrawalRef.id;

    };


  /* =======================================================
     VERIFY PASSWORD
  ======================================================= */

  const handleVerifyPassword =
    async () => {

      if (
        verifying ||
        savingWithdrawal
      ) {
        return;
      }


      setPasswordError("");


      const enteredPassword =
        String(
          withdrawPassword || ""
        ).trim();


      if (!enteredPassword) {

        setPasswordError(
          "Please enter your withdrawal password."
        );

        return;
      }


      if (!securityData) {

        setPasswordError(
          "Security information is unavailable."
        );

        return;
      }


      if (!userId) {

        setPasswordError(
          "Your account could not be identified."
        );

        return;
      }


      setVerifying(true);


      try {

        /* =============================================
           FRESH SECURITY
        ============================================= */

        const securityRef =
          doc(
            db,
            "security",
            username
          );


        const securitySnapshot =
          await getDoc(
            securityRef
          );


        if (
          !securitySnapshot.exists()
        ) {

          throw new Error(
            "Security information was not found."
          );

        }


        const freshSecurityData =
          securitySnapshot.data();


        setSecurityData(
          freshSecurityData
        );


        /* =============================================
           PASSWORD
        ============================================= */

        const savedPassword =
          String(
            freshSecurityData.withdrawPassword ||
            ""
          ).trim();


        if (!savedPassword) {

          throw new Error(
            "Withdrawal password is not configured."
          );

        }


        if (
          enteredPassword !==
          savedPassword
        ) {

          setPasswordError(
            "Incorrect withdrawal password."
          );

          return;
        }


        /* =============================================
           SAVE
        ============================================= */

        setVerifying(false);

        setSavingWithdrawal(true);


        const createdId =
          await saveWithdrawalAndDeductBalance();


        /* =============================================
           SUCCESS
        ============================================= */

        setWithdrawalId(
          createdId
        );


        setVerified(
          true
        );


        setPasswordOpen(
          false
        );


        setWithdrawPassword(
          ""
        );


        setShowPassword(
          false
        );


        setSuccessMessage(
          "Withdrawal confirmed successfully."
        );

      } catch (error) {

        console.error(
          "Withdrawal confirmation error:",
          error
        );


        setPasswordError(
          error?.message ||
          "Unable to complete withdrawal."
        );

      } finally {

        setVerifying(false);
        setSavingWithdrawal(false);

      }

    };


  /* =======================================================
     LOADING
  ======================================================= */

  if (loading) {

    return (
      <div className="confirmed-withdraw-page">

        <div className="confirmed-loading">

          <div className="confirmed-spinner" />

          <span>
            {t("Loading withdrawal details...")}
          </span>

        </div>

      </div>
    );

  }


  /* =======================================================
     NO DATA
  ======================================================= */

  if (!withdrawalData) {
    return null;
  }


  /* =======================================================
     PROCESSING TIME
  ======================================================= */

  const processingTime =
    selectedWithdrawalOption?.time ||
    "-";


  /* =======================================================
     DISPLAY WALLET
  ======================================================= */

  const walletNetwork =
    requestedWalletNetwork ||
    t("Network not specified");


  const walletAddress =
    requestedWalletAddress;


  const walletNumber =
    requestedWalletNumber;


  const walletCode =
    requestedWalletCode;


  const walletCountry =
    requestedWalletCountry;


  /* =======================================================
     RENDER
  ======================================================= */

  return (

    <div className="confirmed-withdraw-page">


      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="confirmed-withdraw-header">

        <button
          type="button"
          className="confirmed-back-btn"
          onClick={() =>
            navigate(
              "/withdraw"
            )
          }
          disabled={
            savingWithdrawal
          }
        >
          ←
        </button>


        <div>

          <h1>
            {t("Confirm Withdrawal")}
          </h1>

          <p>
            {t("Review your withdrawal details")}
          </p>

        </div>

      </div>


      {/* =====================================================
          SUCCESS
      ===================================================== */}

      {successMessage && (

        <div className="confirmed-success">

          <div className="confirmed-success-icon">
            ✓
          </div>


          <div>

            <strong>
              {t("Confirmed")}
            </strong>


            <span>
              {successMessage}
            </span>

          </div>

        </div>

      )}


      {/* =====================================================
          AMOUNT CARD
      ===================================================== */}

      <div className="confirmed-main-card">

        <span className="confirmed-label">
          {t("You will withdraw")}
        </span>


        <div className="confirmed-big-amount">

          {currency}

          {" "}

          {formatAmount(
            amount,
            currency
          )}

        </div>


        <div className="confirmed-status">

          <span
            className={
              verified
                ? "verified-dot"
                : "pending-dot"
            }
          />


          <span>

            {verified
              ? t("Password verified")
              : t("Waiting for confirmation")
            }

          </span>

        </div>


        {verified &&
          withdrawalId && (

            <div className="confirmed-reference">

              {t("Reference:")}
              {" "}
              {withdrawalId}

            </div>

          )}

      </div>


      {/* =====================================================
          WITHDRAWAL DETAILS
      ===================================================== */}

      <div className="confirmed-section">

        <div className="confirmed-section-title">
          {t("Withdrawal Details")}
        </div>


        <div className="confirmed-row">

          <span>
            {t("Withdrawal Speed")}
          </span>

          <strong>
            {t(processingTime)}
          </strong>

        </div>


        <div className="confirmed-row">

          <span>
            {t("Withdrawal Type")}
          </span>

          <strong>
            {selectedWithdrawalOption ? t(selectedWithdrawalOption.label) : "-"}
          </strong>

        </div>


        <div className="confirmed-row">

          <span>
            {t("Withdrawal Fee")}
          </span>

          <strong>
            {feeRate}%
          </strong>

        </div>


        <div className="confirmed-row">

          <span>
            {t("Fee Amount")}
          </span>

          <strong>

            {currency}

            {" "}

            {formatAmount(
              feeAmount,
              currency
            )}

          </strong>

        </div>


        {/* ===============================================
            USDT SOURCE
        =============================================== */}

        {currency === "USDT" && (

          <div className="confirmed-row">

            <span>
              {t("Balance Source")}
            </span>

            <strong>
              {balanceSource}
            </strong>

          </div>

        )}


        {/* ===============================================
            AVAILABLE BALANCE
        =============================================== */}

        {availableBalance > 0 && (

          <div className="confirmed-row">

            <span>
              {t("Available Balance")}
            </span>

            <strong>

              {currency}

              {" "}

              {formatAmount(
                availableBalance,
                currency
              )}

            </strong>

          </div>

        )}


        {/* ===============================================
            EXCHANGE RATE
        =============================================== */}

        {currency === "USDT" &&
          receiveCurrency !== "USDT" &&
          exchangeRate > 0 && (

            <div className="confirmed-row">

              <span>
                {t("Exchange Rate")}
              </span>

              <strong>

                1 USDT ={" "}

                {formatAmount(
                  exchangeRate,
                  receiveCurrency
                )}{" "}

                {receiveCurrency}

              </strong>

            </div>

          )}


        <div className="confirmed-row">

          <span>
            {t("Amount to Receive")}
          </span>

          <strong className="confirmed-green">

            {displayReceiveCurrency}

            {" "}

            {formatAmount(
              displayReceiveAmount,
              displayReceiveCurrency
            )}

          </strong>

        </div>

      </div>


      {/* =====================================================
          CONFIRM BUTTON
      ===================================================== */}

      {!verified ? (

        <button
          type="button"
          className="confirmed-submit-btn"
          onClick={
            handleConfirmedClick
          }
          disabled={
            savingWithdrawal
          }
        >

          {t("CONFIRMED WITHDRAWAL")}

        </button>

      ) : (

        <button
          type="button"
          className="confirmed-done-btn"
          onClick={() =>
            navigate(
              "/withdraw"
            )
          }
        >

          {t("DONE")}

        </button>

      )}


      {/* =====================================================
          CRYPTO WALLET
      ===================================================== */}

      {isCrypto ? (

        <div className="confirmed-section">

          <div className="confirmed-section-title">
            {t("Crypto Wallet")}
          </div>


          <div className="crypto-receive-card">


            {/* ============================================
                CRYPTO ASSET
            ============================================ */}

            <div className="crypto-receive-left">

              <div className="crypto-coin-icon">

                {isBTC
                  ? "₿"
                  : "₮"
                }

              </div>


              <div>

                <span>
                  {t("RECEIVING ASSET")}
                </span>


                <strong>

                  {requestedWalletCoin ||
                    displayReceiveCurrency}

                </strong>

              </div>

            </div>


            {/* ============================================
                {t("NETWORK")}
            ============================================ */}

            <div className="confirmed-conversion">

              <span>
                {t("NETWORK")}
              </span>


              <strong>
                {walletNetwork}
              </strong>

            </div>


            {/* ============================================
                MASKED ADDRESS
            ============================================ */}

            <div className="crypto-wallet-address">

              <span>
                {t("RECEIVING ADDRESS")}
              </span>


              <code>

                {walletAddress
                  ? maskCryptoAddress(
                      walletAddress
                    )
                  : t("Address not available")
                }

              </code>

            </div>


            {/* ============================================
                VERIFIED WALLET
            ============================================ */}

            {walletAddress && (

              <div className="crypto-wallet-confirm-card">

                <div className="crypto-wallet-confirm-top">

                  <div className="crypto-wallet-confirm-icon">

                    {isBTC
                      ? "₿"
                      : "₮"
                    }

                  </div>


                  <div className="crypto-wallet-confirm-name">

                    <strong>

                      {requestedWalletCoin ||
                        displayReceiveCurrency}

                    </strong>


                    <span>
                      {walletNetwork}
                    </span>

                  </div>


                  <div className="crypto-wallet-confirm-status">

                    {t("VERIFIED")}

                  </div>

                </div>


                <div className="crypto-wallet-address">

                  <span>
                    {t("WALLET ADDRESS")}
                  </span>


                  <code>
                    {walletAddress}
                  </code>

                </div>

              </div>

            )}


            {/* ============================================
                BTC CONVERSION
            ============================================ */}

            {isBTC &&
              conversionRate > 0 && (

                <div className="confirmed-conversion">

                  <span>
                    CONVERSION RATE
                  </span>


                  <strong>

                    1 USDT ={" "}

                    {conversionRate.toFixed(8)}

                    {" "}

                    BTC

                  </strong>

                </div>

              )}


            {/* ============================================
                USDT LOCAL PAYOUT RATE
            ============================================ */}

            {currency === "USDT" &&
              !isBTC &&
              receiveCurrency !== "USDT" &&
              exchangeRate > 0 && (

                <div className="confirmed-conversion">

                  <span>
                    {t("PAYOUT CONVERSION")}
                  </span>


                  <strong>

                    1 USDT ={" "}

                    {exchangeRate.toLocaleString(
                      undefined,
                      {
                        maximumFractionDigits: 8,
                      }
                    )}

                    {" "}

                    {receiveCurrency}

                  </strong>

                </div>

              )}

          </div>

        </div>

      ) : (

        /* =================================================
           MOBILE MONEY
        ================================================= */

        <div className="confirmed-section">

          <div className="confirmed-section-title">
            {t("Payment Information")}
          </div>


          <div className="confirmed-info-box">

            <div className="confirmed-info-icon">
              📱
            </div>


            <div className="confirmed-info-content">

              <strong>
                {walletNetwork || t("Mobile Wallet")}
              </strong>


              <span>
                {maskNumber(
                  walletNumber
                )}
              </span>

            </div>


            <div className="confirmed-locked">
              🔒
            </div>

          </div>


          {(walletCode ||
            walletCountry) && (

            <div className="confirmed-wallet-extra">

              {walletCode && (

                <div className="confirmed-row">

                  <span>
                    {t("Wallet Code")}
                  </span>


                  <strong>
                    {walletCode}
                  </strong>

                </div>

              )}


              {walletCountry && (

                <div className="confirmed-row">

                  <span>
                    {t("Country")}
                  </span>


                  <strong>
                    {walletCountry}
                  </strong>

                </div>

              )}

            </div>

          )}

        </div>

      )}


      {/* =====================================================
          USER INFORMATION
      ===================================================== */}

      {verified &&
        securityData && (

          <div className="confirmed-section">

            <div className="confirmed-section-title">
              {t("Your Information")}
            </div>


            <div className="confirmed-user-card">

              <div className="confirmed-user-row">

                <span>
                  {t("Name")}
                </span>


                <strong>

                  {securityData.realName ||
                    userData?.realName ||
                    t("Not available")}

                </strong>

              </div>


              <div className="confirmed-user-row">

                <span>
                  {t("Username")}
                </span>


                <strong>
                  {username}
                </strong>

              </div>


              {securityData.phone && (

                <div className="confirmed-user-row">

                  <span>
                    {t("Phone")}
                  </span>


                  <strong>

                    {maskNumber(
                      securityData.phone
                    )}

                  </strong>

                </div>

              )}

            </div>

          </div>

        )}


      {/* =====================================================
          SECURITY NOTICE
      ===================================================== */}

      {!verified && (

        <div className="confirmed-security-note">

          <span className="confirmed-security-icon">
            🔐
          </span>


          <div>

            <strong>
              {t("Withdrawal password required")}
            </strong>


            <p>
              {t("Confirm your withdrawal by entering")}
              {t("your withdrawal password.")}
            </p>

          </div>

        </div>

      )}


            {/* =====================================================
          PASSWORD MODAL
      ===================================================== */}

{passwordOpen && (
        <div
          className="withdraw-password-overlay"
          onMouseDown={(event) => {
            if (
              event.target === event.currentTarget &&
              !verifying &&
              !savingWithdrawal
            ) {
              closePassword();
            }
          }}
        >

          <div className="withdraw-password-modal">

            {/* ===========================================
                PASSWORD HEADER
            =========================================== */}

            <div className="withdraw-password-header">

              <div>

                <span className="withdraw-password-icon">
                  🔐
                </span>

                <div>

                  <h2>
                    {t("Withdrawal Password")}
                  </h2>

                  <p>
                    {t("Enter your withdrawal password")}
                  </p>

                </div>

              </div>

              <button
                type="button"
                className="withdraw-password-close"
                onClick={closePassword}
                disabled={
                  verifying ||
                  savingWithdrawal
                }
              >
                ×
              </button>

            </div>


            {/* ===========================================
                PASSWORD FIELD
            =========================================== */}

            <div className="withdraw-password-field">

              <label>
                {t("Withdrawal Password")}
              </label>

              <div className="withdraw-password-input-wrap">

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={withdrawPassword}
                  onChange={(event) => {
                    setWithdrawPassword(
                      event.target.value
                    );

                    setPasswordError("");
                  }}
                  onKeyDown={(event) => {
                    if (
                      event.key === "Enter"
                    ) {
                      handleVerifyPassword();
                    }
                  }}
                  placeholder={t("Enter withdrawal password")}
                  autoComplete="current-password"
                  autoFocus
                  disabled={
                    verifying ||
                    savingWithdrawal
                  }
                />

                <button
                  type="button"
                  className="withdraw-password-toggle"
                  onClick={() =>
                    setShowPassword(
                      (value) => !value
                    )
                  }
                  disabled={
                    verifying ||
                    savingWithdrawal
                  }
                >
                  {showPassword
                    ? "Hide"
                    : "Show"}
                </button>

              </div>


              {passwordError && (
                <div className="withdraw-password-error">

                  <span>
                    !
                  </span>

                  <span>
                    {passwordError}
                  </span>

                </div>
              )}

            </div>


            {/* ===========================================
                PASSWORD PREVIEW
            =========================================== */}

            <div className="withdraw-password-preview">

              <div>

                <span>
                  {t("Amount")}
                </span>

                <strong>

                  {currency}{" "}

                  {formatAmount(
                    amount,
                    currency
                  )}

                </strong>

              </div>


              <div>

                <span>
                  {t("Receive")}
                </span>

                <strong className="preview-green">

                  {displayReceiveCurrency}{" "}

                  {formatAmount(
                    displayReceiveAmount,
                    displayReceiveCurrency
                  )}

                </strong>

              </div>

            </div>


            {/* ===========================================
                PASSWORD CONFIRM
            =========================================== */}

            <button
              type="button"
              className="withdraw-password-confirm"
              onClick={handleVerifyPassword}
              disabled={
                verifying ||
                savingWithdrawal
              }
            >

              {verifying ? (
                <>
                  <span className="password-spinner" />
                  {t("VERIFYING...")}
                </>
              ) : savingWithdrawal ? (
                <>
                  <span className="password-spinner" />
                  {t("SUBMITTING...")}
                </>
              ) : (
                "CONFIRM & VERIFY"
              )}

            </button>


            {/* ===========================================
                CANCEL
            =========================================== */}

            <button
              type="button"
              className="withdraw-password-cancel"
              onClick={closePassword}
              disabled={
                verifying ||
                savingWithdrawal
              }
            >
              {t("Cancel")}
            </button>

          </div>

        </div>
      )}

    </div>
  );
}